
import React from 'react';

interface BrandProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'hero';
  withSlogan?: boolean;
  light?: boolean;
}

export const BrandIcon: React.FC<{ className?: string }> = ({ className = "w-full h-full" }) => (
  <svg viewBox="0 0 693.49 1013.86" className={`${className}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Mug Handle */}
    <path 
      stroke="#ffe6ac" 
      strokeWidth="40" 
      strokeMiterlimit="10" 
      d="M515.27,262.67c167.64,47.68,196.66,315.86,2.69,395.92"
    />
    
    {/* Left Bulb Glass */}
    <path fill="#ffe6ac" d="M347.47,967.74H30.56c-46.79-176.45,80.27-367.39,203.2-415.81,68.1-32.39,64.06-134.91,17.16-170.81C225.99,362.94,22.27,196.7,37.98,59.32h309.49s0,908.42,0,908.42Z"/>
    
    {/* Right Bulb Glass */}
    <path fill="#ffe6ac" d="M347.47,967.74h316.91c46.79-176.45-80.27-367.39-203.2-415.81-68.1-32.39-64.06-134.91-17.16-170.81,24.92-18.17,228.64-184.41,212.94-321.79h-309.49s0,908.42,0,908.42Z"/>
    
    {/* Top Beer Bulb */}
    <path fill="#f59e0b" d="M323.19,444.34c-16.46-27.01-8.77-39.34-67.7-87.4C194.62,323.21,61.86,161.89,56.68,81h580.84c14.46,74.56-139.29,245.71-206.51,278.81-81.41,51.45-63.86,34.2-107.82,84.54Z"/>
    
    {/* Hourglass Drip */}
    <path fill="#f59e0b" d="M321.99,467.15c2.04,19.88-4.29,43.1-15.76,61.61-40.25,88.51,66.61,77.46,82.39,17.91,6.49-32.85-20.27-58.35-66.63-79.52Z">
      <animate attributeName="opacity" values="0.7;1;0.7" dur="1.5s" repeatCount="indefinite" />
    </path>
    
    {/* Bottom Beer Bulb */}
    <path fill="#f59e0b" d="M233.87,570.91c72.12,71.25,160.26,54.81,291.58,48.36,103.26,100.62,134.99,227.5,119.64,321.31H47.61c-17.43-153.52,44.66-276.75,186.27-369.67Z"/>
    
    {/* Bubbles in Beer */}
    <circle fill="#ffe6ac" cx="311.72" cy="820.6" r="18.8" opacity="0.6" />
    <circle fill="#ffe6ac" cx="257.17" cy="883.99" r="18.8" opacity="0.6" />
    <circle fill="#ffe6ac" cx="408.38" cy="297.2" r="13.15" opacity="0.6" />
    <circle fill="#ffe6ac" cx="347.58" cy="236.42" r="13.15" opacity="0.6" />
    <circle fill="#ffe6ac" cx="431.26" cy="809.84" r="10.75" opacity="0.6" />
    <circle fill="#ffe6ac" cx="389.58" cy="902.79" r="18.8" opacity="0.6" />
    <circle fill="#ffe6ac" cx="262.81" cy="724.57" r="13.16" opacity="0.6" />
    <circle fill="#ffe6ac" cx="427.49" cy="677.11" r="14.51" opacity="0.6" />
    
    {/* Foam at the Top */}
    <rect fill="#ffe6ac" x="37.26" y="13.62" width="620.13" height="67.38"/>
    <circle fill="#ffe6ac" cx="73.52" cy="77.38" r="24.36"/>
    <circle fill="#ffe6ac" cx="58.84" cy="109.61" r="24.36"/>
    <circle fill="#ffe6ac" cx="115.79" cy="63.77" r="24.36"/>
    <ellipse fill="#ffe6ac" cx="166.65" cy="63.77" rx="36.53" ry="24.36"/>
    <ellipse fill="#ffe6ac" cx="215.34" cy="69.86" rx="36.53" ry="21.85"/>
    <ellipse fill="#ffe6ac" cx="289.4" cy="63.77" rx="26.26" ry="21.85"/>
    <ellipse fill="#ffe6ac" cx="110.95" cy="91.71" rx="37.43" ry="21.85"/>
    <circle fill="#ffe6ac" cx="63.96" cy="35.94" r="33.91"/>
    <ellipse fill="#ffe6ac" cx="137.15" cy="35.94" rx="57.42" ry="33.91"/>
    <ellipse fill="#ffe6ac" cx="215.34" cy="41.91" rx="41.86" ry="36.66"/>
    <circle fill="#ffe6ac" cx="634.74" cy="35.37" r="35.37"/>
    <ellipse fill="#ffe6ac" cx="587.78" cy="35.41" rx="32.12" ry="27.17"/>
    <ellipse fill="#ffe6ac" cx="533.27" cy="23.5" rx="20.24" ry="18.24"/>
    <ellipse fill="#ffe6ac" cx="506.53" cy="30.09" rx="20.24" ry="18.24"/>
    <ellipse fill="#ffe6ac" cx="466.05" cy="21.17" rx="20.24" ry="18.24"/>
    <ellipse fill="#ffe6ac" cx="445.81" cy="23.5" rx="20.24" ry="18.24"/>
    <ellipse fill="#ffe6ac" cx="353.8" cy="23.5" rx="20.24" ry="18.24"/>
    <ellipse fill="#ffe6ac" cx="255.53" cy="86.73" rx="21.9" ry="19.36"/>
    <ellipse fill="#ffe6ac" cx="390.6" cy="23.5" rx="39.23" ry="18.24"/>
    <ellipse fill="#ffe6ac" cx="302.37" cy="21.17" rx="39.23" ry="18.24"/>
    <path fill="#ffe6ac" d="M666.94,66.75c0,20.25-19.87,65.67-42.99,65.67s-40.74-45.43-40.74-65.67,18.74-36.66,41.86-36.66,41.86,16.41,41.86,36.66Z"/>
    <ellipse fill="#ffe6ac" cx="220.97" cy="101.73" rx="18.76" ry="21.85"/>
    <ellipse fill="#ffe6ac" cx="161.28" cy="106.1" rx="24.13" ry="36.24"/>
    <ellipse fill="#ffe6ac" cx="193.81" cy="126.87" rx="27.16" ry="57.01"/>
    
    {/* Base of the Mug */}
    <rect fill="#c49a6c" x="0" y="963.45" width="693.49" height="50.4" rx="20" ry="20"/>
  </svg>
);

export const BrandSlogan: React.FC<{ size?: string, className?: string }> = ({ size = "text-base", className = "" }) => (
  <p className={`text-amber-500 font-black tracking-[0.3em] uppercase heading-font drop-shadow-[0_4px_16px_rgba(0,0,0,0.8)] ${size} ${className}`}>
    Your Local Happy Hour Guide
  </p>
);

export const BrandLogo: React.FC<BrandProps> = ({ size = 'md', withSlogan = false, className = "", light = false }) => {
  const sizeMap = {
    sm: { text: 'text-base', icon: 'w-4 h-6', gap: 'gap-1.5', slogan: 'text-[8px]' },
    md: { text: 'text-xl md:text-2xl', icon: 'w-5 h-8 md:w-6 md:h-9', gap: 'gap-2 md:gap-3', slogan: 'text-[10px]' },
    lg: { text: 'text-4xl md:text-6xl', icon: 'w-10 h-14 md:w-16 md:h-24', gap: 'gap-4 md:gap-6', slogan: 'text-xs md:text-sm' },
    hero: { 
      text: 'text-5xl xs:text-6xl sm:text-7xl md:text-9xl lg:text-[11.5rem]', 
      icon: 'w-16 h-24 xs:w-20 xs:h-30 sm:w-24 sm:h-36 md:w-28 md:h-44 lg:w-36 lg:h-52', 
      gap: 'gap-2 sm:gap-4 md:gap-6', 
      slogan: 'text-[10px] sm:text-lg md:text-xl lg:text-2xl' 
    }
  };

  const currentSize = sizeMap[size as keyof typeof sizeMap] || sizeMap.md;
  const isHero = size === 'hero';

  return (
    <div className={`flex flex-col items-center group cursor-pointer ${className}`}>
      <div className={`flex items-center justify-center ${currentSize.gap} whitespace-nowrap overflow-hidden w-full`}>
        <span className={`${currentSize.text} font-black tracking-tight heading-font shrink-0 transition-colors duration-500 ${light ? 'text-white group-hover:text-amber-400' : 'text-black group-hover:text-amber-600'}`}>
          Hoppy
        </span>
        <div className={`
          ${currentSize.icon} relative transform transition-all duration-700 ease-out 
          ${isHero ? 'animate-subtle-tilt group-hover:rotate-[8deg] group-hover:scale-105' : ''}
        `}>
          <BrandIcon />
        </div>
        <span className={`${currentSize.text} font-bold tracking-tight heading-font shrink-0 transition-colors duration-500 ${light ? 'text-white group-hover:text-amber-400' : 'text-black group-hover:text-amber-600'}`}>
          Hours
        </span>
      </div>
      {withSlogan && (
        <BrandSlogan size={currentSize.slogan} className="mt-2 md:mt-4 transition-transform group-hover:scale-105" />
      )}
    </div>
  );
};
